<script>
    export let fixed;
</script>
<div class="loader-wrapper {fixed === true? 'loader-fixed': ''}">
    <h1 class="text-center text-primary pt-5">
    <span class="spinning-loader"></span>
    </h1>
    <h3 class="text-center text-muted">Loading...</h3>
</div>
